/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-multifactor-authentication',
    templateUrl: './multifactor-authentication.component.html',
    styleUrls: ['./multifactor-authentication.component.css']
})
export class MultiFactorAuthenticationComponent implements OnInit, AfterViewInit {

    otpDigits: string[] = ['', '', '', '', '', ''];
    boxes = new Array(6);
    mLoading = false;
    mCanResend = false; // initially disabled
    mError = '';
    mDisplayErrorPopup = false;
    resendCountdown = 0; // countdown in seconds
    resendTimer: any;

    constructor(private authService: AuthenticationService, private router: Router) { }

    ngOnInit(): void {
        const flag = localStorage.getItem("multifactorUser");

        // If user typed URL manually or refreshed without login
        if (!flag) {
            this.router.navigate(['/login']);
            return;
        }

        this.startResendTimer();
    }

    ngAfterViewInit(): void {
        // Request Focus to the input of the first code character
        const element = document.getElementById("otpcode0");
        if (element != null && element != undefined) {
          element.focus();
        }
    }

    startResendTimer(): void {
        this.mCanResend = false;
        this.resendCountdown = 25; // 5 seconds countdown

        this.resendTimer = setInterval(() => {
            this.resendCountdown--;
            if (this.resendCountdown <= 0) {
                this.mCanResend = true;
                clearInterval(this.resendTimer);
            }
        }, 1000);
    }

    async verifyOtpClicked() {
        const otp = this.otpDigits.join('').trim();
        this.mError = '';

        //1. Check if OTP is empty or incomplete
        if (!otp || otp.length < 6) {
            this.mError = 'Please enter the 6-digit Code.';
            this.mDisplayErrorPopup = true;
            setTimeout(() => (this.mDisplayErrorPopup = false), 3000);
            return; // stop here
        }

        this.mLoading = true;

        try {
            const multifactorUser = JSON.parse(localStorage.getItem('multifactorUser'));
            const phone = multifactorUser.cellNumber;
            const userId = multifactorUser.id;

            const res = await this.authService.verifyOtp(otp, userId, phone);

            // Save fully authenticated user info
            await this.authService['setCurrentUserInfo'](res.user, res.jwtToken);

            // Remove multifactor user
            localStorage.removeItem('multifactorUser');

            // Redirect to home
            this.router.navigateByUrl('/home');

        } catch (error: any) {
          console.error("Problem validating MFA code.", error);
            // Read clean error message from backend
            this.mError = error?.error?.error || error?.error || 'Invalid / Expired Code.';

            this.mDisplayErrorPopup = true;
            setTimeout(() => (this.mDisplayErrorPopup = false), 3000);

        } finally {
            this.mLoading = false;
        }
    }


    async resendMultiFactorOtp() {
        this.mCanResend = false;
        clearInterval(this.resendTimer);

        try {
            const multifactorUser = JSON.parse(localStorage.getItem('multifactorUser'));
            const phone = multifactorUser.cellNumber;


            await this.authService.resendOtp(phone);

            console.log('OTP resent successfully.');
        } catch (error: any) {
            this.mError = error.error || 'Failed to resend OTP.';
            this.mDisplayErrorPopup = true;
            setTimeout(() => this.mDisplayErrorPopup = false, 3000);
        } finally {
            this.startResendTimer();
        }
    }
    moveToNext(event: any, index: number) {
        const keyboardEvent = event as KeyboardEvent;

        // If enter is pressed, try to verify the code..
        if (keyboardEvent.key === 'Enter') {
          this.verifyOtpClicked();
          return;
        } 
        // Ignore the events if it's Tab or Shift...
        else if (keyboardEvent.key == 'Tab' || keyboardEvent.key == 'Shift') {
          return; 
        }
      
        // Focus / Select the input for the next code
        const input = keyboardEvent.target as HTMLInputElement;
        if (input.value && index < this.boxes.length - 1) {
            const nextBox = input.nextElementSibling as HTMLInputElement;
            if (nextBox) {
              nextBox.select();
            }
        } else if (!input.value && index > 0) {
            const prevBox = input.previousElementSibling as HTMLInputElement;
            if (prevBox) {
              prevBox.select();
            }
        } else {
            input.select();
        }
    }

}
